import { render, staticRenderFns } from "./matchold.vue?vue&type=template&id=5dbce43f&lang=pug&"
import script from "./matchold.vue?vue&type=script&lang=js&"
export * from "./matchold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports